export default __webpack_public_path__ + "static/Kharma_Mohammad_Zertifikat-min-9ee08200292a57e2202cad6d86106154.pdf";